import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/profil.png'


const _withScopeId = n => (_pushScopeId("data-v-75bd4eb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pannel flex flex-column p-3 gap-2" }
const _hoisted_2 = { class: "flex justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "profil-img",
  src: _imports_0,
  alt: "profil-picture"
}
const _hoisted_5 = { class: "font-normal" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "color-tag text-white app-label-micro uppercase bg-primary-blue" }
const _hoisted_8 = { class: "flex app-label-small text-gray-l1" }
const _hoisted_9 = { class: "flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.user.picture_url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "profil-img",
            src: _ctx.user.picture_url,
            alt: "profil-picture"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ]),
    _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.userFullName), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userLicense), 1)
    ]),
    _createElementVNode("span", _hoisted_8, " Dernière connexion le " + _toDisplayString(_ctx.lastLoginDate), 1),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, { to: "/user-profile" }, {
        default: _withCtx(() => [
          _createVNode(_component_app_button, {
            buttonType: "secondary",
            buttonSize: "m",
            isDisabled: false,
            iconName: "ci-action-edit",
            buttonText: _ctx.$t('homeview.profil-left-bar.edit-profil-button')
          }, null, 8, ["buttonText"])
        ]),
        _: 1
      })
    ])
  ]))
}